import { render, staticRenderFns } from "./BuildStats.vue?vue&type=template&id=4d5f64c8&"
import script from "./BuildStats.vue?vue&type=script&lang=js&"
export * from "./BuildStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports